import { create, type MessageShape } from "@bufbuild/protobuf";
import { ValueSchema } from "@bufbuild/protobuf/wkt";
import { ERR_INVALID_BOOLEAN } from "#lib/validation.js";

export const boolOptionTrue = "True";
export const boolOptionFalse = "False";

function makeBoolValue(val: boolean): MessageShape<typeof ValueSchema> {
	return create(ValueSchema, { kind: { case: "boolValue", value: val } });
}

export function makeBoolValueFromString(val: string): MessageShape<typeof ValueSchema> | undefined {
	if (val === boolOptionTrue) {
		return makeBoolValue(true);
	}
	if (val === boolOptionFalse) {
		return makeBoolValue(false);
	}
	return undefined;
}

export function validateBoolean(value: boolean | undefined): string | undefined {
	if (value === undefined || typeof value === "boolean") {
		return undefined;
	}
	return ERR_INVALID_BOOLEAN;
}

export function booleanDisplayValue(value: boolean | undefined): string {
	if (value === undefined) {
		return "";
	}
	return value ? boolOptionTrue : boolOptionFalse;
}
